<div>
  <!-- Tooltip container -->
  <div class="tooltip-container">
    <div
      class="opt-out-tooltip"
      [class.show]="showOptOutTooltip"
      [style.left.px]="tooltipPosition.x"
      [style.top.px]="tooltipPosition.y"
    >
      {{ tooltipMessage }}
    </div>
  </div>

  <app-table
    [columns]="tableColumns"
    [data]="cdfiOutreachLogs"
    [loading]="loading"
    [noResultsMessage]="'No logs found.'"
  >
    <ng-template let-business>
      <tr
        [class.opted-out]="!business.is_active"
        (mouseenter)="
          !business.is_active
            ? showTooltip(
                $event,
                business.meta_data?.['deactivation_reason'] ?? 0
              )
            : null
        "
        (mouseleave)="!business.is_active ? hideTooltip() : null"
      >
        <td class="business-name">
          {{ business.business_name }}
        </td>
        <td class="date-column">
          <div class="date-with-action">
            <span>{{ business.email_sent_at_utc | date: "medium" }}</span>
            @if (business.is_active) {
              <button
                class="email-icon-btn"
                (click)="viewEmailEvents(business.id, business.business_name)"
                title="Track email"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 65"
                  width="22"
                  height="15"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-width="6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <!-- Speed lines -->
                    <path d="M 21,17 L 30,17" />
                    <path d="M 13,27 L 24,27" />
                    <path d="M 5,39 L 19,39" />

                    <!-- Envelope body -->
                    <path
                      d="M 40,11 
                           L 90,11 
                           A 5,5 0 0,1 95,16
                           L 88,50 
                           A 5,5 0 0,1 83,54
                           L 33,54 
                           A 5,5 0 0,1 28,49
                           L 35,16
                           A 5,5 0 0,1 40,11 Z"
                    />

                    <!-- Envelope flap and details -->
                    <path d="M 37,13 L 59,32 A 4,4 0 0,0 65,32 L 92,13" />
                    <path d="M 31,48 L 52,31" />
                    <path d="M 85,51 L 69,32" />
                  </g>
                </svg>
              </button>
            }
          </div>
        </td>
        <td>
          {{ business.form_view_count }}
        </td>
        <td>
          <span
            [class]="
              +business.status === 3
                ? 'status-badge expired'
                : +business.status === 2
                  ? 'status-badge submitted'
                  : +business.status === 1
                    ? 'status-badge sent'
                    : 'status-badge queued'
            "
          >
            {{
              +business.status === 3
                ? "Expired"
                : +business.status === 2
                  ? "Submitted"
                  : +business.status === 1
                    ? "Sent"
                    : "Pending"
            }}
          </span>
        </td>
        <td class="date-column">
          {{ business.form_submitted_at_utc | date: "medium" }}
        </td>
        @if (showActiveClientColumn) {
          <td class="active-client-count">
            <span class="count-badge">
              {{ business.lead_status_active_client ?? 0 }}
            </span>
          </td>
        }
        <td>
          <div class="action-icons">
            @if (business.is_active) {
              <a
                href="javascript:void(0)"
                (click)="viewBusinessDetails(business.unique_id)"
              >
                View
              </a>
            } @else {
              <span class="disabled-action"> View </span>
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </app-table>
</div>

@if (showRecordDetails) {
  <app-record-details
    [unique_id]="uniqueId"
    (popupClosed)="showRecordDetails = false"
  ></app-record-details>
}

@if (showEmailEvents) {
  <app-email-events-popup
    [outreachId]="selectedOutreachId"
    [businessName]="selectedBusinessName"
    (popupClosed)="showEmailEvents = false"
  ></app-email-events-popup>
}
